export const PAYMENT_CONFIGURATIONS = {
    BTN_SAVE_PAYMENT_CONFIGURATIONS: "save-payment-configurations",
    BTN_MANAGE_RETAIL_SEGMENTATION: "manage-retail-segmentation",
    LOADING: "loading-payment-configurations",
    GRID: "grid-payment-configurations",
    RESET_GROUP_PERMISSIONS: "reset-group-permissions",
    REMOVE_GROUP: "remove-group",
    NEW_GROUP: {
        BODY: "payment-configurations-new-group-body",
        BTN_SAVE: "payment-configurations-new-group-save",
        BTN_CANCEL: "payment-configurations-new-group-cancel",
        BTN_OPEN: "payment-configurations-new-group-open",
        NAME: "payment-configurations-new-group-name",
        TYPE: "payment-configurations-new-group-type",
        TYPE_BRAND: "payment-configurations-new-group-type-brand",
        TYPE_RETAIL: "payment-configurations-new-group-type-retail",
    },
    MANAGE_RETAIL_SEGMENTATION: {
        DIALOG: "payment-configurations-manage-retail-segmentation-dialog",
        RADIO_GROUP: "payment-configurations-manage-retail-segmentation-radio-group",
        RADIO_NO: "payment-configurations-manage-retail-segmentation-radio-no",
        RADIO_YES: "payment-configurations-manage-retail-segmentation-radio-yes",
        AVAILABLE_FIELDS_DROPDOWN: "payment-configurations-manage-retail-segmentation-available-fields-dropdown",
        BUTTON_CLOSE: "payment-configurations-manage-retail-segmentation-button-close",
        BUTTON_SAVE: "payment-configurations-manage-retail-segmentation-button-save",
    },
};
